module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAq0lEQVR4AWOgD1CpBaLlmy/x6rcAGfgQBDCp1cGFyrt2IasQNSquqXRgVa9G0bBy62W4CuOA6XC2hVfSo/289dV26DZgtT0yMfD7Wea/FxlKil0IaygtcQYqhaBZvYbYNWw/eEvKqgvkjVInoDo4eriPj0m1BqcNdVX2MKUIBHQedg19rebvjrND0M9zTHANLw5z2frGo2sgjDA1tNRbQ4zERH5RYWTZMCgBAEV8lQl+bxmbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TK.png
// module id = 1280
// module chunks = 0